var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMongolia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2b65ae",
    d: "M10 0h10v24H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c93336",
    d: "M0 24V0h10v24zm20 0V0h10v24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7d448",
    d: "M5 6.13a1.53 1.53 0 1 0 0 3.05 1.53 1.53 0 0 0 0-3.05M2 9.45h1.36V16H2zm4.64 0H8V16H6.64zm-3 0h2.72L5 10.27zm0 1.1h2.72v.54H3.64zm0 3.81h2.72v.55H3.64zm0 .82h2.72L5 16zM5 11.36a1.36 1.36 0 1 0 0 2.73 1.36 1.36 0 0 0 0-2.73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongolia);
export default __webpack_public_path__ + "static/media/mongolia.7469d9de29284e2ba072a3e565b12195.svg";
export { ForwardRef as ReactComponent };